module.exports = __webpack_public_path__ + "a07db7063c7cbb4b7507ab93a6ce5589.svg";